import { render, staticRenderFns } from "./CollectionVideoHeader.vue?vue&type=template&id=37931f67&scoped=true&name=collection-video-header&"
import script from "./CollectionVideoHeader.vue?vue&type=script&lang=js&"
export * from "./CollectionVideoHeader.vue?vue&type=script&lang=js&"
import style0 from "./CollectionVideoHeader.vue?vue&type=style&index=0&id=37931f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37931f67",
  null
  
)

export default component.exports